import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  Authentication,
  ChangePassword,
  Password,
} from '@rivethealth/data/auth';
import { ROUTER_API_URL } from './common';

@Injectable({ providedIn: 'root' })
export class PasswordService {
  constructor(
    @Inject(ROUTER_API_URL) private readonly routerUrl: string,
    private readonly http: HttpClient,
  ) {}

  generateAuthentication(email: string, password: string) {
    const auth = `Basic ${btoa(`${email}:${password}`)}`;
    return this.http.post<Authentication>(
      `${this.routerUrl}/passwords/auth`,
      null,
      { headers: { Authorization: auth } },
    );
  }

  modifyPassword(userId: number, password: ChangePassword) {
    const auth = `Basic ${btoa(
      `${password.email}:${password.currentPassword}`,
    )}`;
    return this.http.put(
      `${this.routerUrl}/passwords/change/${userId}`,
      JSON.stringify(password.newPassword),
      { headers: { 'Content-Type': 'application/json', Authorization: auth } },
    );
  }

  adminModifyPassword(userId: number, password: Password) {
    return this.http.put(
      `${this.routerUrl}/passwords/${userId}`,
      JSON.stringify(password),
      { headers: { 'Content-Type': 'application/json' } },
    );
  }

  resetPassword(email: string, password: Password, token: string) {
    return this.http.put(
      `${this.routerUrl}/passwords?email=${encodeURIComponent(email)}`,
      { password },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }

  createPassword(email: string, password: Password, token: string) {
    return this.http.put(
      `${this.routerUrl}/passwords/create?email=${encodeURIComponent(email)}`,
      { password },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }

  sendResetEmail(email: string) {
    return this.http.post(
      `${this.routerUrl}/passwords/email/${encodeURIComponent(email)}`,
      null,
    );
  }
  sendInvitationEmail(sendingUserId: number, email: string, accountId: number) {
    return this.http.post(
      `${this.routerUrl}/saml/email/${encodeURIComponent(
        email,
      )}/${accountId}/${sendingUserId}`,
      { url: `${location.origin}/login` },
    );
  }
}
